export default __webpack_public_path__ + "static/shopping-centre-2-ca518c46ddb911c07c371b3e89682636.jpg";